import { useEffect } from 'react';
import classnames from 'classnames';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

const TABS = t => [
  {
    label: t('reports_root.cash_movements'),
    path: APP_LINKS.cash_movements,
  },
  {
    label: t('reports_root.portfolio_movements'),
    path: APP_LINKS.portfolio_movements,
  },
  {
    label: t('reports_root.tax_report'),
    path: APP_LINKS.taxReports,
  },
];

const ReportsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('reports');

  useEffect(() => {
    if (location.pathname === APP_LINKS.reports) {
      navigate(APP_LINKS.cash_movements, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className={s.page}>
      <div className="container-inner">
        <div className={s.header}>
          <h1 className="f-hero-h2">{t('reports_root.reports')}</h1>
          <p className="f-paragraph-regular">
            {t('reports_root.view_analyze')}
          </p>
        </div>

        <div className={s.navigation}>
          {TABS(t).map(tab => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                classnames(
                  s.link,
                  isActive && s.link_active,
                  'f-article-regular',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default ReportsPage;
